



















import { Vue, Component } from 'vue-property-decorator'
import LanguageSelectorComponent from './languageSelector.vue'
import { config } from '@/setup/config'

@Component({
  components: {
    LanguageSelectorComponent
  },
  i18n: {
    messages: {
      en: {
        website: 'Website'
      },
      ru: {
        website: 'Веб-сайт'
      }
    }
  }
})
export default class HeaderComponent extends Vue {
  get phone () {
    return config.company.phone
  }

  get website () {
    return config.company.website
  }
}
